import { render, staticRenderFns } from "./FreePlan.vue?vue&type=template&id=61930b3c&"
import script from "./FreePlan.vue?vue&type=script&lang=js&"
export * from "./FreePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports